import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

import * as Yup from 'yup';

import { CenteredModal, Input, SubmitButton } from 'components';
import { Form, Formik } from 'formik';
import { useFormikDispatchSubmit } from 'hooks/useFormikSubmit';
import { createPanel, refreshCurrentClient, ThunkDispatch } from 'store';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    textAlign: 'right',
  },
}));

interface FormValues {
  name: string;
  organizationId?: string;
}

const initialValues = {
  name: '',
};

const validationSchema = Yup.object().shape({ name: Yup.string().required() });

interface Props {
  organizationId?: string;
  onRequestClose: () => void;
  isOpen: boolean;
}

export const AddPanelModal = ({
  organizationId,
  isOpen,
  onRequestClose,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const dispatch = useDispatch<ThunkDispatch>();
  const { t } = useTranslation();

  const createNewPanel = (values: FormValues) => {
    return createPanel({ ...values, organizationId });
  };
  const onSuccess = () => {
    onRequestClose();
    dispatch(refreshCurrentClient());
  };
  const submit = useFormikDispatchSubmit(createNewPanel, { onSuccess });

  return (
    <CenteredModal
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      title={t('settings.panels.addModal.title')}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={submit}
      >
        <Form>
          <div>
            <Input
              name="name"
              label={t('settings.panels.addModal.name.label')}
            />
          </div>
          <div className={classes.button}>
            <SubmitButton text={t('settings.panels.addModal.submitButton')} />
          </div>
        </Form>
      </Formik>
    </CenteredModal>
  );
};
